import styles from "./main-menu.module.scss";
import { Link } from "react-router-dom";
import { Route } from "../../navigation/routes";

const MainMenu = ({ name, href, image }: Route) => {
  return (
    <Link to={href} className={styles.menu__item}>
      <p className={styles.menu__name}>{name}</p>
    </Link>
  );
};
export default MainMenu;
